import styled from "styled-components";

const CalendarHeader = styled.div`
  justify-content: center;
  display: flex;

  h4 {
    display: flex;
    flex: 1 1;
    justify-content: space-around;
    align-items: center;
  }

  .icon {
    cursor: pointer;
  }
`;

const CalendarDays = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  margin: 0;

  font-weight: bold;
  text-align: center;

  & > div {
    align-self: center;
    border-right: 1px dotted silver;

    padding: 4px;

    &:first-child,
    &:last-child {
      background: none;
      border: none;
    }

    &:last-child {
      min-width: 50px;
    }
  }
  & .icon {
    cursor: pointer;
    font-size: 1.5em;
  }
  & .iconPrev {
    text-align: left;
  }
  & .iconNext {
    text-align: right;
  }
`;

const CalendarCells = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  & > div {
    border-right: 1px dotted silver;

    text-align: center;
    cursor: pointer;
  }

  .disabled {
    color: grey;
    background: repeating-linear-gradient(
      45deg,
      white,
      #ddd 5px,
      white 5px,
      #ddd 10px
    );
    cursor: default;
  }

  .today {
    background-color: rgba(0, 123, 255, 0.1);
    cursor: pointer;
  }

  .day {
    height: 100%;
    padding: 4px;
    border: 2px solid transparent;

    &.selected {
      border: 2px solid red;
      font-weight: bold;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      padding: 0.75rem 0.5rem !important;
    }
  }
  & .firstDayOfWeek {
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    padding: 0;

    & > div > span {
      color: whitesmoke;
      position: absolute;
      left: 3px;
      top: 9px;
      font-weight: bold;
    }
  }
  & .sumOfWeek {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border: none;
    padding: 0;
    padding-left: 4px;
    min-width: 50px;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: 1.25rem;
      padding-right: ${({ theme }) => theme.spacing.md};
    }
  }
`;

const CalendarFooter = styled.div`
  display: flex;
  margin: 0;
  font-weight: bold;
  border-top: 1px solid;
  border-bottom: 2px solid;
  border-left: 1px solid;
  border-right: 1px solid;
  padding: 4px;
  flex-direction: row;
  justify-content: space-between;
`;
export default { CalendarHeader, CalendarDays, CalendarCells, CalendarFooter };
